"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var fileReader = exports.fileReader = function fileReader(file) {
  return new Promise(function (resolve, reject) {

    var reader = new FileReader();
    reader.onloadend = function (e) {
      resolve(e.target.result);
    };
    reader.onerror = function (e) {
      reject(e.message);
    };

    reader.readAsDataURL(file);
  });
};


//////////////////
// WEBPACK FOOTER
// ./util/file-reader.js
// module id = 613
// module chunks = 0